import { TermsAgreement } from 'src/presentation/pages'

export const makeTermsAgreement = () => <TermsAgreement />
